import { Image } from "react-native";
import { Button, Text, View } from "../../Components/Themed";
import type { AthleteProps, BracketCompetitionProps, BracketProps, CompetitionPlayerBracketProps, LeagueProps, PlayerBracketProps, TeamProps } from "../../types"
import React from 'react';
import { Icons } from "../../Components";
import { useColors } from "../../constants/useColors";

type PlayerBracketCardProps = {
    league?:LeagueProps,
    bracket:BracketProps,
    champion_team?:TeamProps,
    champion_athlete?:AthleteProps,
    onEdit: (player_bracket:PlayerBracketProps) => void,
    onShowCompetitions:() => void,
    onView: (bracket_id:string, player_bracket_id?:string, bracket_competition?:BracketCompetitionProps) => void,
    bracket_competitions:BracketCompetitionProps[],
    player_bracket:PlayerBracketProps,
    competition_player_brackets:CompetitionPlayerBracketProps[]
}

const PlayerBracketCard = ({ onEdit, champion_team, onView, player_bracket, bracket, competition_player_brackets, onShowCompetitions }:PlayerBracketCardProps) => {
    const Colors = useColors();
    
    return (
        <View type='row' style={{ flex:1 }}>
            {player_bracket.champion_id ?
            <View style={{ borderBottomLeftRadius:8, borderRightWidth:1, borderColor:Colors.borders.light }}>
                {champion_team ? 
                <View transparent style={{ flex:1, padding:10, justifyContent:'space-between' }}>
                    <Image
                        source={{ uri: champion_team.image?.url }}
                        style={{ height:30, width:30 }}
                        resizeMode='cover'
                    />
                    <Text theme="description" textAlign="center">{champion_team.abbr}</Text>
                </View>
                :<></>}
            </View>
            :
            <View style={{ borderBottomLeftRadius:8, borderRightWidth:1, borderColor:Colors.borders.light }}>
                    <View transparent style={{ flex:1, padding:10, justifyContent:'space-between' }}>
                    <Icons.BracketIcon size={16} color={Colors.text.h1} />
                    <Text theme="h1" textAlign="center">...</Text>
                </View>
            </View>
            }
            <View style={{ flex:1, marginLeft:8, marginRight:8 }}>
               <Text theme="h1">{player_bracket.bracket_name}</Text>
               <Text style={{ marginTop:4 }} theme="description">{(player_bracket.completion_pct * 100).toFixed(2)}%</Text>
            </View>
            {competition_player_brackets.length > 0 ?
            <Button float style={{ flexDirection:'row', alignItems:'center', padding:10 }} onPress={() => onShowCompetitions()}>
                <Text style={{ marginRight:5 }} theme="h1" color={Colors.text.action}>{competition_player_brackets.length}</Text>
                <Icons.TrophyIcon size={12} color={Colors.text.action} />
            </Button>
            :<></>}
            {player_bracket.status != 'closed' ?
            <Button
                type='text'
                style={{ padding:10, marginRight:5 }}
                onPress={() => onEdit(player_bracket)}
            >
                <Icons.EditIcon size={14} color={Colors.text.action} />
            </Button>
            :<></>}
            <Button
                title="VIEW"
                type='text'
                style={{ padding:10 }}
                onPress={() => onView( bracket.bracket_id, player_bracket.player_bracket_id)}
            />
        </View>
    )
}

export default React.memo(PlayerBracketCard, (left, right) => {
    if(JSON.stringify(left) != JSON.stringify(right)){return false }
    return true
})


/*
<View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                {league ?
                <Image
                    source={{ uri: league?.league_image }}
                    style={{ height:40, width:40 }}
                    resizeMode="cover"
                />
                :
               <></>
                }
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme="h1">{player_bracket.bracket_name}</Text>
                    <Text style={{ marginTop:3 }} theme="description">{bracket.bracket_name}</Text>
                </View>
                <Button
                    type='text'
                    title="EDIT"
                    style={{ padding:10, marginRight:5 }}
                    onPress={() => onEdit(player_bracket)}
                />
                <Button
                    title="VIEW"
                    style={{ padding:10 }}
                    type='action'
                    onPress={() => onView( bracket.bracket_id, player_bracket.player_bracket_id)}
                />
            </View>
*/